<template>
	<a-row type="flex">
		<a-col :span="24">
			<h6 class="text-uppercase"><strong>Comments</strong></h6>
			<evolution-comment :series="this.comments" v-if="!loading" />
			<loading :isLoading="loading" />
		</a-col>
		<a-col :span="24" v-if="post.isVideo">
			<h6 class="text-uppercase"><strong>Views</strong></h6>
			<evolution-views :series="this.views" v-if="!loading" />
			<loading :isLoading="loading" />
		</a-col>
		<a-col :span="24">
			<h6 class="text-uppercase"><strong>Likes</strong></h6>
			<evolution-likes :series="this.likes" v-if="!loading" />
			<loading :isLoading="loading" />
		</a-col>
	</a-row>
</template>

<script>
import Loading from '@/components/widgets/loading'
import EvolutionComment from '@/components/widgets/Post/Analysis/EvolutionComment'
import EvolutionLikes from '@/components/widgets/Post/Analysis/EvolutionLikes'
import EvolutionViews from '@/components/widgets/Post/Analysis/EvolutionViews'

import * as ACTIONS from '@/store/actions'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
	name: 'PostEvolution',
	components: {
		EvolutionComment,
		EvolutionLikes,
		EvolutionViews,
		Loading,
	},
	props: {
		post: {
			type: Object,
			required: true,
		},
	},
	data: function() {
		return {
			moment,
			loading: true,
			likes: [{}],
			views: [{}],
			comments: [{}],
		}
	},
	created() {
		this.loadPostEvolution({
			where: {
				id: this.post.id,
			},
			limit: 50,
		}).then(res => {
			this.likes = [
				{
					name: 'Likes',
					data: res.map(item => {
						return [moment(item.evolutionCreatedAt).utc(), item.likes]
					}),
				},
			]

			this.views = [
				{
					name: 'Views',
					data: res.map(item => {
						return [moment(item.evolutionCreatedAt).utc(), item.views]
					}),
				},
			]

			this.comments = [
				{
					name: 'Comments',
					data: res.map(item => {
						return [moment(item.evolutionCreatedAt).utc(), item.comments]
					}),
				},
			]

			this.loading = false
		})
	},
	methods: {
		...mapActions({
			loadPostEvolution: ACTIONS.POST.EVOLUTION,
		}),
	},
}
</script>

<style></style>
